import { useMutation } from "@tanstack/react-query";

import { env } from "@/config/env";
import authenticatedApi from "@/lib/api/client";

const BASE_URL = env.VITE_BASE_API_URL;

const downloadZipFile = async (fileIds: number[]) => {
  const queryParams = `fileIds=${fileIds.join(",")}`;

  const { token } = await authenticatedApi
    .url(`/my-files/download/bulk/files/token?${queryParams}`)
    .get()
    .json<{ token: string }>();

  const link = document.createElement("a");

  link.href = `${BASE_URL}/api/v1/my-files/download/bulk/from-token?token=${token}`;
  link.download = "";

  document.body.append(link);
  link.click();
  link.remove();
};

export function useDownloadBulkFiles() {
  return useMutation({
    mutationFn: async (fileIds: number[]) => {
      await downloadZipFile(fileIds);
    },
  });
}
